export const MODULE_NAME = 'integrations';

export const INTEGRATION = 'integration';
export const INTEGRATIONS = 'integrations';
export const RELOAD_INTEGRATIONS = 'reloadIntegrations';
export const REMOVE_INTEGRATION = 'removeIntegration';
export const SAVE_INTEGRATION = 'saveIntegration';
export const SET_INTEGRATION = 'setIntegration';
export const SET_INTEGRATIONS = 'setIntegrations';
export const SHOW_MODAL_INTEGRATION = 'showModalIntegration';

export const SITEBOD = 'sitebod';
export const SITEBODS = 'sitebods';
export const RELOAD_SITEBODS = 'reloadSiteBods';
export const REMOVE_SITEBOD = 'removeSiteBods';
export const SAVE_SITEBOD = 'saveSiteBods';
export const SET_SITEBOD = 'setSiteBod';
export const SET_SITEBODS = 'setSiteBods';
export const SHOW_MODAL_SITEBOD = 'showModalSiteBod';

export const THIRD_PARTIES = 'thirdparties';
export const THIRD_PARTY = 'thirdparty';
export const RELOAD_THIRD_PARTIES = 'reloadThirdParties';
export const SET_LAST_THIRD_PARTYID = 'setLastThirdPartyId';
export const SAVE_THIRD_PARTY = 'saveThirdParty';
export const SET_THIRD_PARTIES = 'setThirdParties';
export const CLEAR_THIRD_PARTIES = 'clearThirdParties';
export const SET_THIRD_PARTY = 'setThirdParty';
export const SHOW_MODAL_THIRDPARTY = 'showModalThirdParty';

export const TRANSACTIONS = 'transactions';

export const VERSIONS = 'versions';
export const SET_VERSIONS = 'setVersions';
export const SET_VERSION_ITEMS = 'setVersionItems';
export const CLEAR_VERSION_ITEMS = 'clearVersionItems';
export const UPDATE_VERSIONS = 'updateVersions';

export const TOAST_MESSAGES_PUSH = 'toastMessages/push';
export const REFERENCE_ID = 'referenceId';
